import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import { Motion } from '@sohanscript/ui/motion';
import type { ComponentProps } from 'react';
import { Img } from '@/components/image';
import type { RouterOutputs } from '@/server/root';
import { Button } from '../ui/button';

export type ProjectCardProps = ComponentProps<typeof Motion> &
	RouterOutputs['project']['homepage'][number] & { isActive: boolean };

export function ProjectCard({
	thumbnail,
	title,
	slug,
	liveLink,
	isActive,
	className,
	...props
}: ProjectCardProps) {
	return (
		<Motion feature="domMax" className="group" layoutId={slug?.current} {...props}>
			<div
				suppressHydrationWarning
				style={{ perspective: 500, perspectiveOrigin: 'bottom' }}
				className={cn(
					'relative m-4 mx-auto block max-w-sm bg-primary/5 p-4 shadow-lg',
					className,
				)}
			>
				<div
					className={cn(
						'relative h-56 w-full origin-bottom overflow-hidden rounded-[8px] transition-transform duration-500 group-hover:rotate-x-32',
						{
							'pointer-events-none': !isActive,
						},
					)}
				>
					<Img
						src={thumbnail}
						width={500}
						className="h-full w-full object-cover object-top"
					/>
				</div>
				<p className="pt-2 font-semibold text-primary">{title}</p>
			</div>

			<Button
				className="absolute inset-x-0 top-14 mx-auto h-8 w-fit not-group-hover:opacity-0 transition-opacity delay-200"
				variant="outline"
				onPointerDown={(e) => e.stopPropagation()}
				href={`/work/${slug?.current ?? ''}`}
			>
				{m.pc_explore()}
				<Iconify icon="proicons:open" className="size-4" />
			</Button>
		</Motion>
	);
}
